/// <amd-module name="Wit/WorkItemForm/Common/Services/IWorkItemFormService" />
import { IObservableValue } from "VSS/Core/Observable";
import { IVssService } from "VSS/Platform/Context";
import { FormLayout } from "Wit/Clients/Wit/Contracts/WorkItemFormLayout";
import { CommentFormat, WorkItemUpdate } from "Wit/Clients/Wit/Contracts/WorkItemTracking";
import { IWorkItemTypeData } from "Wit/WorkItemDataManager/Contracts";

export interface IWorkItemFormService extends IVssService {
    workItemHistoryPromise: IObservableValue<Promise<IHistoryItem[]> | undefined>;

    getWorkItemFormLayout(workItemTypeData: IWorkItemTypeData): FormLayout;
    getTagsData(projectGuid: string): Promise<string[]>;
    getHistoryData(workItemId: number, projectId: string): Promise<IHistoryItem[]>;
    resetHistoryData(): void;
}

// TODO: generate this interface with genclient
export interface ICommentEdit {
    workItemRevision: number;
    commentId: number;
    commentVersion: number;
    text: string;
    previousText: string;
    format: CommentFormat;
}

// TODO: generate this interface with genclient
export interface IHistoryItem extends WorkItemUpdate {
    commentEdit?: ICommentEdit;
}
